import { ApiError } from "../api";
import { isCancelledRequest, mapRequestOutcome } from "./outcome";

export function eventFeedback(error: unknown) {
  if (isCancelledRequest(error)) return "unknown";
  if (error instanceof ApiError) {
    const codes = [
      "event_closed",
      "event_revision_changed",
      "event_reinvitation_required",
      "event_recipient_unavailable",
      "version_conflict",
      "award_cancellation_required",
      "sourcing_opening_time_conflict",
      "opening_source_changed",
      "opening_already_opened",
      "opening_qualification_required",
      "opening_too_early",
      "opening_window_open",
      "opening_case_exists",
      "opening_already_confirmed",
      "opening_next_round_required",
      "qualification_not_opened",
      "qualification_source_changed",
      "qualification_locked",
      "qualification_invalid",
      "round_draft_conflict",
    ] as const;
    const code = codes.find((value) => error.code === value);
    if (code) return code;
  }
  return mapRequestOutcome(error);
}

export function eventAuthorityLost(error: unknown) {
  return (
    ["unauthorized", "forbidden", "notFound"].includes(
      mapRequestOutcome(error),
    ) && !(error instanceof ApiError && error.code === "operation_not_found")
  );
}
